import EventDetailsModal from '@/App/Events/Details/components/EventDetailsModal'
import CreateEventDialog from '@/App/Agendas/Details/components/CreateEventDialog'
import type { Agenda } from '@/services/agendas'

type Props = {
  selectedEvent: { agendaId: string; eventId: string } | null
  newEventOpen: boolean
  agendas: Agenda[]
  onCloseEvent: () => void
  onCloseNew: (open: boolean) => void
  defaultDate?: string
}

const CalendarModals = ({ selectedEvent, newEventOpen, agendas, onCloseEvent, onCloseNew, defaultDate }: Props) => {
  const selectedAgenda = selectedEvent
    ? agendas.find((a) => a.id === selectedEvent.agendaId)
    : null

  return (
    <>
      {selectedEvent && (
        <EventDetailsModal
          agendaId={selectedEvent.agendaId}
          eventId={selectedEvent.eventId}
          permissions={selectedAgenda?.permissions ?? []}
          open={!!selectedEvent}
          onClose={onCloseEvent}
        />
      )}
      {newEventOpen && (
        <CreateEventDialog
          open
          onOpenChange={onCloseNew}
          agendas={agendas}
          defaultDate={defaultDate}
        />
      )}
    </>
  )
}

export default CalendarModals
